(() => {
  const PDP_001_PATH = '/products/001-no-context-lakier-hybrydowy-czysta-biel-7-ml';

  const with001View = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || url.pathname !== PDP_001_PATH) return value;
      if (!url.searchParams.has('view')) url.searchParams.set('view', 'bn001');
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (_error) {
      return value;
    }
  };

  const route001Links = (scope = document) => {
    scope.querySelectorAll?.(`a[href*="${PDP_001_PATH}"]`).forEach((link) => {
      const nextHref = with001View(link.getAttribute('href') || '');
      if (nextHref) link.setAttribute('href', nextHref);
    });
  };

  const MONOGRAM_LAYER_COUNTS = {
    start: 3,
    drop: 3
  };

  const MONOGRAM_SVG = '<svg viewBox="0 0 35.13 95.17" aria-hidden="true" focusable="false"><path d="M0,11.66s5.63,6.94,6.08,8.36.19,55.48.19,55.48c0,0,8.8,9.12,15.14,9.75l13.11-14.38-.44-32.55s0-3.36,1.77-3.99-12.98-4.62-12.98-4.62l-7.47,6.46,8.87,4.37s.63,32.55,0,35.59l-8.36-6.65s-.44-42.5.32-52.06l5.51-14.38s-10.96,6.21-12.67,10.01L0,11.66Z"/></svg>';

  const ensureMonogramStyles = () => {
    if (document.getElementById('bn-page-single-monogram-styles')) return;
    const style = document.createElement('style');
    style.id = 'bn-page-single-monogram-styles';
    style.textContent = `
      #bn-start-starter-kits,#bn-start-systems{position:relative;overflow:hidden}
      .bn-page-single-monogram{position:absolute;z-index:0;right:clamp(18px,4vw,72px);top:clamp(24px,4vw,64px);display:block;width:clamp(92px,11vw,168px);height:clamp(245px,29vw,410px);color:rgba(111,23,48,.065);pointer-events:none}
      .bn-page-single-monogram svg{display:block;width:100%;height:100%;fill:currentColor}
      #bn-start-starter-kits>*:not(.bn-page-single-monogram),#bn-start-systems>*:not(.bn-page-single-monogram){position:relative;z-index:1}
      @media(max-width:749px){.bn-page-single-monogram{right:12px;top:18px;width:86px;height:230px;color:rgba(111,23,48,.055)}}
    `;
    document.head.appendChild(style);
  };

  const ensurePageSingleMonograms = () => {
    if (window.location.pathname !== '/pages/zacznij') return;
    const source = document.querySelector('[data-bn-page-single] svg, .bnx-b-stack svg, .bn-home-monogram svg');
    if (!source) return;

    ensureMonogramStyles();
    ['bn-start-starter-kits', 'bn-start-systems'].forEach((id) => {
      const host = document.getElementById(id);
      if (!host || host.querySelector('[data-bn-page-single]')) return;
      const mark = document.createElement('span');
      mark.className = 'bn-page-single-monogram';
      mark.dataset.bnPageSingle = '';
      mark.setAttribute('aria-hidden', 'true');
      mark.appendChild(source.cloneNode(true));
      host.appendChild(mark);
    });
  };

  const cleanupLegacyMonograms = (scope = document) => {
    scope.querySelectorAll?.('.bnx-b-stack').forEach((stack) => stack.remove());
  };

  const ensureDropVideoControlStyles = () => {
    if (document.getElementById('bn-drop-video-control-styles')) return;
    const style = document.createElement('style');
    style.id = 'bn-drop-video-control-styles';
    style.textContent = `
      .bn-drop-card__media[data-bn-video-media]{position:relative;cursor:pointer;overflow:hidden}
      .bn-drop-card__media[data-bn-video-media] video{transition:transform .28s ease,filter .28s ease}
      .bn-drop-card__media[data-bn-video-media].is-video-playing video{transform:scale(1.025);filter:saturate(1.08)}
      .bn-drop-video-control{position:absolute;z-index:8;left:50%;top:50%;display:grid;width:58px;height:58px;place-items:center;transform:translate(-50%,-50%);border:0;border-radius:0;clip-path:polygon(25% 3%,75% 3%,100% 50%,75% 97%,25% 97%,0 50%);background:linear-gradient(135deg,rgba(255,255,255,.96),rgba(217,63,126,.9) 45%,rgba(112,72,158,.94));filter:drop-shadow(0 9px 15px rgba(0,0,0,.3));color:#fff;pointer-events:none;transition:transform .2s ease,background .2s ease}
      .bn-drop-video-control:after{content:"";position:absolute;inset:2px;clip-path:inherit;background:rgba(10,9,14,.84)}
      .bn-drop-video-control:before{content:"";display:block;margin-left:4px;border-top:8px solid transparent;border-bottom:8px solid transparent;border-left:13px solid currentColor}
      .bn-drop-video-control:before{position:relative;z-index:1}
      .bn-drop-card__media[data-bn-video-media]:is(:hover,:focus-visible) .bn-drop-video-control{transform:translate(-50%,-50%) scale(1.08);background:linear-gradient(135deg,#741b35,#71499e)}
      .bn-drop-card__media[data-bn-video-media].is-video-playing .bn-drop-video-control:before{width:12px;height:15px;margin:0;border:0;border-left:4px solid currentColor;border-right:4px solid currentColor}
      @media(max-width:749px){.bn-drop-video-control{width:52px;height:52px}}
    `;
    document.head.appendChild(style);
  };

  const ensureHexVideoStyles = () => {
    if (document.getElementById('bn-hex-video-control-styles')) return;
    const style = document.createElement('style');
    style.id = 'bn-hex-video-control-styles';
    style.textContent = `
      :where(.bnx-video-trigger,.bnx-hero-video-control,.bn-drop-card__play,.bn-drop-video-control,.bnsv__see-track i,.bnsv__step-media>button,.bn-home-social .play){
        border:0!important;border-radius:0!important;
        clip-path:polygon(25% 3%,75% 3%,100% 50%,75% 97%,25% 97%,0 50%)!important;
        background:linear-gradient(135deg,rgba(111,23,48,.96),rgba(217,63,126,.94) 46%,rgba(112,72,158,.96))!important;
        color:#fff!important;filter:drop-shadow(0 9px 14px rgba(0,0,0,.3));
      }
      :where(.bnx-video-trigger,.bnx-hero-video-control) small{display:none!important}
      :where(.bnx-video-trigger,.bnx-hero-video-control)>span{display:grid!important;place-items:center!important;width:100%!important;height:100%!important;font:900 16px/1 Arial,sans-serif!important}
      .bnsv__see-track i{width:36px!important;height:36px!important;font-size:11px!important}
      .bn-home-social .play{width:36px!important;height:36px!important;right:10px!important;top:10px!important}
      @media(max-width:749px){
        :where(.bnx-video-trigger,.bnx-hero-video-control){min-width:48px!important;min-height:48px!important}
        .bnsv__see-track i{width:42px!important;height:42px!important}
      }
    `;
    document.head.appendChild(style);
  };

  const ensureHomeMonogramStyles = () => {
    if (document.getElementById('bn-home-art-monogram-styles')) return;
    const style = document.createElement('style');
    style.id = 'bn-home-art-monogram-styles';
    style.textContent = `
      body.bn-home-v2 :is([data-bn-quick-clean],[data-bn-drop-live],.bn-start-bridge,[data-bn-home-steps-six],[id^="BNHomeFaq-"],.bn-home-looks,.bn-home-community){position:relative;isolation:isolate;overflow:hidden}
      .bn-home-art-b{position:absolute!important;z-index:0;display:block;pointer-events:none}
      .bn-home-art-b svg{display:block;width:100%;height:100%;fill:currentColor}
      .bn-home-art-b--single{width:clamp(105px,10vw,170px);height:clamp(285px,28vw,455px);right:clamp(16px,4vw,68px);top:clamp(24px,5vw,74px);color:rgba(111,23,48,.075)}
      .bn-home-art-b--triple{right:clamp(-16px,1vw,18px);top:clamp(18px,4vw,58px);width:clamp(240px,23vw,380px);height:clamp(390px,40vw,610px)}
      .bn-home-art-b--triple>span{position:absolute;inset:0;display:block;width:42%;height:88%}
      .bn-home-art-b--triple>span:nth-child(1){left:0;top:8%;color:rgba(217,63,126,.24);transform:rotate(-5deg)}
      .bn-home-art-b--triple>span:nth-child(2){left:27%;top:0;color:rgba(112,72,158,.24);transform:rotate(3deg)}
      .bn-home-art-b--triple>span:nth-child(3){left:53%;top:11%;color:rgba(109,159,203,.22);transform:rotate(7deg)}
      [data-bn-drop-live] .bn-home-art-b--triple{mix-blend-mode:screen}
      [data-bn-drop-live] .bn-home-art-b--triple>span{opacity:.82}
      [data-bn-home-art="looks-triple"]{left:clamp(-82px,-3vw,-28px);right:auto;top:auto;bottom:clamp(-150px,-8vw,-82px);opacity:.58}
      [data-bn-home-art="community-triple"]{left:clamp(-72px,-2vw,-24px);right:auto;top:clamp(58px,8vw,118px);opacity:.48;mix-blend-mode:screen}
      body.bn-home-v2 :is([data-bn-drop-live],.bn-start-bridge)>.bn-home-monogram{position:absolute!important;z-index:0!important;pointer-events:none!important}
      body.bn-home-v2 :is([data-bn-quick-clean],[data-bn-drop-live],.bn-start-bridge,[id^="BNHomeFaq-"],.bn-home-looks,.bn-home-community)>:not(.bn-home-art-b):not(.bn-home-monogram){position:relative;z-index:1}
      @media(max-width:749px){
        .bn-home-art-b--single{right:10px;top:24px;width:88px;height:236px;color:rgba(111,23,48,.06)}
        .bn-home-art-b--triple{right:-54px;top:30px;width:230px;height:390px;opacity:.72}
        [data-bn-home-art="looks-triple"]{left:-78px;right:auto;top:auto;bottom:-116px;opacity:.42}
        [data-bn-home-art="community-triple"]{left:-84px;right:auto;top:44px;opacity:.4}
      }
    `;
    document.head.appendChild(style);
  };

  const buildMonogram = (key, layers = 1) => {
    const mark = document.createElement('span');
    mark.className = `bn-home-art-b bn-home-art-b--${layers === 3 ? 'triple' : 'single'}`;
    mark.dataset.bnHomeArt = key;
    mark.setAttribute('aria-hidden', 'true');
    if (layers === 3) {
      for (let index = 0; index < 3; index += 1) {
        const layer = document.createElement('span');
        layer.innerHTML = MONOGRAM_SVG;
        mark.appendChild(layer);
      }
    } else {
      mark.innerHTML = MONOGRAM_SVG;
    }
    return mark;
  };

  const ensureHomeArtMonograms = () => {
    if (!document.body.classList.contains('bn-home-v2')) return;
    ensureHomeMonogramStyles();
    document.querySelectorAll('[data-bn-home-art="start"],[data-bn-home-art="drop"]').forEach((mark) => mark.remove());
    const placements = [
      ['[data-bn-quick-clean]', 'quick', 1],
      ['.bn-home-looks', 'looks-triple', 3],
      ['.bn-home-community', 'community-triple', 3],
      ['[id^="BNHomeFaq-"]', 'faq', 1]
    ];
    placements.forEach(([selector, key, layers]) => {
      const host = document.querySelector(selector);
      if (!host || host.querySelector(`[data-bn-home-art="${key}"]`)) return;
      host.appendChild(buildMonogram(key, layers));
    });
  };

  const initCollectionDropVideos = (scope = document) => {
    if (window.location.pathname !== '/collections/nowosci-dropy') return;
    ensureDropVideoControlStyles();

    scope.querySelectorAll?.('[data-bn-drop-live] .bn-drop-card__media').forEach((media) => {
      const video = media.querySelector('video');
      if (!video || media.dataset.bnVideoMedia === 'true') return;

      media.dataset.bnVideoMedia = 'true';
      media.removeAttribute('href');
      media.setAttribute('role', 'button');
      media.setAttribute('tabindex', '0');
      media.setAttribute('aria-label', `Odtwórz wideo: ${media.getAttribute('aria-label') || 'drop'}`);

      const control = document.createElement('span');
      control.className = 'bn-drop-video-control';
      control.setAttribute('aria-hidden', 'true');
      media.appendChild(control);

      const toggle = async () => {
        if (!video.paused) {
          video.pause();
          return;
        }
        document.querySelectorAll('[data-bn-drop-live] video').forEach((candidate) => {
          if (candidate !== video && !candidate.paused) candidate.pause();
        });
        try { await video.play(); } catch (_error) {}
      };

      media.addEventListener('click', (event) => {
        event.preventDefault();
        toggle();
      });
      media.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggle();
      });
      video.addEventListener('play', () => {
        media.classList.add('is-video-playing');
        media.setAttribute('aria-label', `Pauza wideo: ${media.getAttribute('aria-label')?.replace(/^Odtwórz wideo: /, '').replace(/^Pauza wideo: /, '') || 'drop'}`);
      });
      video.addEventListener('pause', () => {
        media.classList.remove('is-video-playing');
        media.setAttribute('aria-label', `Odtwórz wideo: ${media.getAttribute('aria-label')?.replace(/^Odtwórz wideo: /, '').replace(/^Pauza wideo: /, '') || 'drop'}`);
      });
    });
  };

  const enhanceMonogram = (monogram) => {
    if (!monogram) return;

    const source = monogram.querySelector('svg');
    if (!source) return;

    const key = monogram.dataset.bnHomeMonogram || '';
    const layerCount = MONOGRAM_LAYER_COUNTS[key] || 1;

    if (layerCount === 1) {
      monogram.replaceChildren(source.cloneNode(true));
      monogram.classList.remove('bno-b-stack-inline');
      monogram.classList.add('bno-b-single-inline');
      monogram.dataset.bnLayerCount = '1';
      return;
    }

    const fragment = document.createDocumentFragment();
    for (let index = 0; index < layerCount; index += 1) {
      const layer = document.createElement('span');
      layer.className = 'bno-b-stack-inline__layer';
      layer.setAttribute('aria-hidden', 'true');
      layer.appendChild(source.cloneNode(true));
      fragment.appendChild(layer);
    }

    monogram.replaceChildren(fragment);
    monogram.classList.remove('bno-b-single-inline');
    monogram.classList.add('bno-b-stack-inline');
    monogram.dataset.bnLayerCount = String(layerCount);
  };

  const boot = (scope = document) => {
    document.body.classList.add('bn-burgundy-ombre-v4');
    ensureHexVideoStyles();
    ensurePageSingleMonograms();
    cleanupLegacyMonograms(scope);
    scope.querySelectorAll?.('.bn-home-monogram').forEach(enhanceMonogram);
    initCollectionDropVideos(scope);
    ensureHomeArtMonograms();
    route001Links(scope);
  };

  if (window.location.pathname === PDP_001_PATH) {
    const currentUrl = new URL(window.location.href);
    if (!currentUrl.searchParams.has('view')) {
      currentUrl.searchParams.set('view', 'bn001');
      window.location.replace(currentUrl.toString());
      return;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('pointerdown', (event) => {
    const link = event.target.closest?.(`a[href*="${PDP_001_PATH}"]`);
    if (link) link.setAttribute('href', with001View(link.getAttribute('href') || ''));
  }, true);

  document.addEventListener('play', (event) => {
    const video = event.target;
    if (!(video instanceof HTMLVideoElement) || !video.closest('[data-bn-drop-live]')) return;
    document.querySelectorAll('[data-bn-drop-live] video').forEach((candidate) => {
      if (candidate !== video && !candidate.paused) candidate.pause();
    });
  }, true);

  const monogramObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('.bnx-b-stack')) node.remove();
        else cleanupLegacyMonograms(node);
        if (node.matches('.bn-home-monogram')) enhanceMonogram(node);
        node.querySelectorAll?.('.bn-home-monogram').forEach(enhanceMonogram);
      });
    });
  });
  monogramObserver.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('load', () => boot(), { once: true });
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('shopify:section:reorder', () => boot());
})();
